import Event from '../../core/Event';

export default class OrderPlaceRequested extends Event {
    public static type = 'OrderPlaceRequested';

    constructor() {
        super(OrderPlaceRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderPlaceRequested.ts